import standardAPI from '@/api/standard_items';

const responseUrl = '/organisation-tours/guides';

const state = {
  guides: [],
  guides_MetaData: {},
  guides_status: '',
  guides_page: 1,
  guides_perPage: 10,
};

const getters = {
  get_guides: (state) => {
    return state.guides;
  },
  get_guides_status: (state) => {
    return state.guides_status;
  },
};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_guides ({ commit }, getOptions) {
    commit('DATA_GUIDES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('DATA_GUIDES_UPDATE_SUCCESS', response);
            commit('DATA_GUIDES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('DATA_GUIDES_READY');
            reject(response);
          } else {
            commit('DATA_GUIDES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_guides_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_guide ({ commit, dispatch }, itemData) {
    commit('DATA_GUIDES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('DATA_GUIDES_REQUEST');
          resolve(response);
        } else {
          commit('DATA_GUIDES_READY');
          reject(response);
        }
      });
    });
  },
  edit_guide ({ commit, dispatch }, itemData) {
    commit('DATA_GUIDES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('DATA_GUIDES_REQUEST');
          resolve(response);
        } else {
          commit('DATA_GUIDES_READY');
          reject(response);
        }
      });
    });
  },
  remove_guides ({ commit, dispatch }, itemData) {
    commit('DATA_GUIDES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('DATA_GUIDES_REQUEST');
          resolve();
        } else {
          commit('DATA_GUIDES_READY');
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.guides_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.guides_perPage = max;
  },
  DATA_GUIDES_READY: (state) => {
    state.guides_status = 'ready';
  },
  DATA_GUIDES_REQUEST: (state) => {
    state.guides_status = 'loading';
  },
  DATA_GUIDES_UPDATE_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.guides_MetaData.meta = response.meta;
      state.guides_MetaData.links = response.links;
    }
    if (response && response.data) {
      state.guides = response.data || [];
    }
    state.guides_status = 'success';
  },
  DATA_GUIDES_ERROR: (state) => {
    state.guides_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
